const translateElement = (element) => {
  if (element.classList.contains('js-parallax-active')) {
    const speed = 0.1;
    const offset = element.getBoundingClientRect().top;

    element.style.transform = `translateY(${offset * speed}px)`;
  }
};

const handleIntersection = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting && window.innerWidth > 768) {
      entry.target.classList.add('js-parallax-active');
    } else {
      entry.target.classList.remove('js-parallax-active');
    }
  });
};

const handleScrollAndLoad = (parallaxItems) => {
  parallaxItems.forEach((item) => {
    translateElement(item);
  });
};

document.addEventListener('DOMContentLoaded', function () {
  const parallaxItems = document.querySelectorAll('.js-parallax');

  const observer = new IntersectionObserver(handleIntersection);

  parallaxItems.forEach((item) => {
    observer.observe(item);
  });

  window.addEventListener('load', () => {
    setTimeout(() => {
      handleScrollAndLoad(parallaxItems);
    }, 200);
  });

  window.addEventListener('scroll', () => {
    handleScrollAndLoad(parallaxItems);
  });
});
